import { render, staticRenderFns } from "./NecessitiesSelection.vue?vue&type=template&id=360ce541&scoped=true"
import script from "./NecessitiesSelection.vue?vue&type=script&lang=js"
export * from "./NecessitiesSelection.vue?vue&type=script&lang=js"
import style0 from "./NecessitiesSelection.vue?vue&type=style&index=0&id=360ce541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ce541",
  null
  
)

export default component.exports